const API_URL = process.env.REACT_APP_API_URL;
const ASSETS_URL = process.env.REACT_APP_ASSETS_URL;

/**
 * Vendor-scoped API base (e.g. https://host/api/vendor) — login, logout, lab profile, vendor modules.
 * Platform routes such as /backoffice/* live under /api only; see apiRootUrl.
 */
const apiUrl = API_URL;

/** Base URL for /api without trailing /vendor — used by axios for /backoffice/* and other non-vendor-prefix routes */
const apiRootUrl =
    typeof apiUrl === 'string' && apiUrl.length > 0
        ? apiUrl.replace(/\/vendor\/?$/i, '')
        : apiUrl;

const config = {
    apiUrl,
    apiRootUrl,
    assetsUrl: ASSETS_URL,
};

export default config;